var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"m50 70c2.7656 0 5-2.2383 5-5v-10h10c2.7656 0 5-2.2383 5-5s-2.2344-5-5-5h-10v-10c0-2.7617-2.2344-5-5-5s-5 2.2383-5 5v10h-10c-2.7656 0-5 2.2383-5 5s2.2344 5 5 5h10v10c0 2.7617 2.2344 5 5 5z","key":0}),React.createElement("path",{"d":"m50 10c-22.055 0-40 17.945-40 40s17.945 40 40 40c7.2188 0 14.328-1.9805 20.566-5.7305 2.3711-1.4258 3.1289-4.4961 1.7031-6.8633-1.4258-2.375-4.5039-3.1367-6.8594-1.7031-4.6797 2.8125-10.004 4.2969-15.41 4.2969-16.547 0-30-13.453-30-30s13.453-30 30-30 30 13.453 30 30c0 5.3984-1.4883 10.73-4.3047 15.414-1.4219 2.3633-0.65625 5.4336 1.7109 6.8594 2.3594 1.4219 5.4336 0.65625 6.8633-1.7109 3.75-6.2383 5.7305-13.348 5.7305-20.562 0-22.055-17.945-40-40-40z","key":1})]));
}

Plus.defaultProps = {"width":"100%","height":"100%","version":"1.1","viewBox":"0 0 100 100"};

module.exports = Plus;

Plus.default = Plus;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/plus.svg
// module id = 412
// module chunks = 0